/**
 * External Link Icon
 */

import type { IconProps } from '../../types';

export function ExternalLinkIcon({ 
  className, 
  size = 24, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'External link',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" x2="21" y1="14" y2="3" />
    </svg>
  );
}

